import React, { useEffect, useState } from "react";
import AllNews from "./AllNews";
import MyFav from "./MyFav";
import "./styles/index.css";

const HackerNews = () => {
  const [data, setData] = React.useState({ hits: [...Array(9).keys()] });
  const [query, setQuery] = React.useState("angular");
  const [page, setPage] = React.useState("all");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [storedHackerNewsLiked] = useState(
    JSON.parse(localStorage.getItem("hackerNewsLiked")) || []
  );
  const fetchData = (query, pageNumber) => {
    fetch(
      `https://hn.algolia.com/api/v1/search_by_date?query=${query}&page=${pageNumber}`
    )
      .then((response) => response.json())
      .then((data) => {
        setData(data);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchData(query, pageNumber);
  }, [query, pageNumber]);

  return (
    <div>
      <nav>Hacker News</nav>
      <br />
      <div className="page_selector">
        <button
          className={`${page === "all" ? "selected" : ""}`}
          onClick={() => setPage("all")}
        >
          All
        </button>
        <div className="vl"></div>
        <button
          className={`${page === "favs" ? "selected" : ""}`}
          onClick={() => setPage("favs")}
        >
          My faves
        </button>
      </div>
      {page === "all" ? (
        <AllNews
          storedHackerNewsLiked={storedHackerNewsLiked}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          data={data}
          query={query}
          setQuery={setQuery}
        />
      ) : (
        <MyFav pageNumber={pageNumber} setPageNumber={setPageNumber} />
      )}
    </div>
  );
};
export default HackerNews;
